import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchAdministrador} from '../../../../store/empresa';
import EmpresaAdministradorCreatePage from './_create';
import EmpresaAdministradorDetailPage from './_detail';
import EmpresaAdministradorEditPage from './_edit';

export default function EmpresaAdministradorPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchAdministrador({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/administradores/:id/edit" component={EmpresaAdministradorEditPage} />
        <Route path="/*/empresas/:empresaId/administradores/create" component={EmpresaAdministradorCreatePage} />
        <Route path="/*/empresas/:empresaId/administradores/:id" component={EmpresaAdministradorDetailPage} />
      </Switch>);
}
